import React from 'react';
import { getVisibleSettingsSections } from './settingsSections';

export default function SettingsSectionNav({ activeId, onSelect, isAdmin, isSuperAdmin }) {
  const groups = getVisibleSettingsSections({ isAdmin, isSuperAdmin });

  return (
    <nav
      className="lg:sticky lg:top-6 space-y-6"
      aria-label="Settings sections"
    >
      {groups.map((group) => (
        <div key={group.id}>
          <p className="px-3 mb-2 text-[10px] font-semibold uppercase tracking-[0.14em] text-gray-400">
            {group.label}
          </p>
          <ul className="space-y-1">
            {group.items.map((item) => {
              const Icon = item.icon;
              const isActive = activeId === item.id;

              return (
                <li key={item.id}>
                  <button
                    type="button"
                    onClick={() => onSelect(item.id)}
                    className={`w-full flex items-start gap-3 rounded-xl px-3 py-3 text-left transition-all duration-200 ${
                      isActive
                        ? 'bg-gray-900 text-white shadow-md shadow-gray-900/10'
                        : 'text-gray-700 hover:bg-white hover:shadow-sm border border-transparent hover:border-gray-200/80'
                    }`}
                  >
                    <span
                      className={`mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-lg ${
                        isActive ? 'bg-white/15 text-orange-300' : 'bg-gray-100 text-gray-600'
                      }`}
                    >
                      <Icon className="h-4 w-4" strokeWidth={1.75} />
                    </span>
                    <span className="min-w-0">
                      <span className={`block text-sm font-semibold leading-tight ${isActive ? 'text-white' : 'text-gray-900'}`}>
                        {item.label}
                      </span>
                      <span className={`block text-xs mt-0.5 truncate ${isActive ? 'text-gray-300' : 'text-gray-500'}`}>
                        {item.description}
                      </span>
                    </span>
                  </button>
                </li>
              );
            })}
          </ul>
        </div>
      ))}
    </nav>
  );
}
